/**
 * UUIDv7 — time-ordered, so a queue of offline sales sorts by creation without a second field.
 *
 * `crypto.randomUUID()` is v4 and unordered. The backend already uses `Guid.CreateVersion7()` for
 * every primary key; matching it here means an idempotency key and the row it eventually creates
 * sort the same way, which is what makes an offline queue replay in the order it was rung up.
 */
export function uuidv7(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // 48 bits of Unix milliseconds, big-endian, in the first six bytes.
  const now = BigInt(Date.now());
  for (let i = 0; i < 6; i++) {
    bytes[i] = Number((now >> BigInt(8 * (5 - i))) & 0xffn);
  }

  bytes[6] = (bytes[6]! & 0x0f) | 0x70; // version 7
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // variant 10

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
